import React from "react";
import styles from './PageBody.styles';

export default function PageBody({ children }) {
    return <div style={styles.pageBody}>
            {children}
        </div>
}